<button
  #anchor
  kendoButton
  look="flat"
  class="user-menu-trigger"
  (click)="toggleMenu()"
  [attr.aria-expanded]="isMenuOpen"
>
  <span class="user-avatar">
    @if (userPhoto) {
      <img [src]="userPhoto" [alt]="userFullName" class="user-avatar__photo" />
    } @else {
      <span class="user-avatar__initials">{{ userInitials }}</span>
    }
  </span>
  <span class="user-name">{{ userFullName }}</span>
</button>

<kendo-popup
  #popup
  [anchor]="anchor"
  [anchorAlign]="{ horizontal: 'right', vertical: 'bottom' }"
  [popupAlign]="{ horizontal: 'right', vertical: 'top' }"
  [animate]="true"
  *ngIf="isMenuOpen"
  (anchorViewportLeave)="closeMenu()"
>
  <kendo-card class="user-menu-card" width="280px" (mouseleave)="closeMenu()">
    <kendo-card-body>
      <div class="menu-header">
        <span class="menu-avatar">
          @if (userPhoto) {
            <img [src]="userPhoto" [alt]="userFullName" class="menu-avatar__photo" />
          } @else {
            <span class="menu-avatar__initials">{{ userInitials }}</span>
          }
        </span>
        <div class="menu-info">
          <div class="menu-info__name">{{ userFullName }}</div>
          <div class="menu-info__email">{{ userEmail }}</div>
        </div>
      </div>
    </kendo-card-body>
    <div class="menu-divider"></div>
    <div class="menu-actions">
      <button kendoButton look="flat" (click)="onAccountClick()" class="menu-action">
        <i class="fa-light fa-user"></i>
        <span>My Account</span>
      </button>
      <button kendoButton look="flat" (click)="onLogoutClick()" class="menu-action">
        <i class="fa-light fa-arrow-right-from-bracket"></i>
        <span>Log out</span>
      </button>
    </div>
  </kendo-card>
</kendo-popup>
